import type { Step } from '../pages/Onboarding.types'

export const steps: Step[] = [
  {
    disclaimer: {
      description: (
        <>
          Your financial information is private and will never be shared with
          your employer or any third party. If you choose to speak with a CFP®,
          your information is shared with them only with your permission. This
          helps them provide more personalized guidance during your
          conversation.
          <br />
          <br />
          Completing this form is not required to explore the platform, but it
          must be completed before booking time with a CFP®.
        </>
      ),
      title: 'Disclaimer information',
    },
    fields: [
      {
        field_name: 'date',
        isBirthDate: true,
        isFinancial: false,
        isHidden: false,
        placeholder: 'MM.DD.YYYY',
        question: 'Date of birth',
        type: 'date',
      },
      {
        field_name: 'gender',
        isFinancial: false,
        isGenderField: true,
        isHidden: false,
        options: [
          'Male',
          'Female',
          'Non-binary',
          'Transgender',
          'Prefer not to say',
          'Other',
        ],
        placeholder: 'Select your gender',
        question: 'How would you describe your gender?',
        type: 'select',
      },
      {
        field_name: 'ethnicity',
        isFinancial: false,
        isHidden: false,
        isRaceField: true,
        options: [
          'Asian',
          'Black or African American',
          'Hispanic or Latino',
          'Native Hawaiian or Other Pacific Islander',
          'Caucasian',
          'Middle Eastern or North African',
          'Prefer not to say',
          'Other',
        ],
        placeholder: 'Select your race or ethnicity',
        question: 'What race or ethnicity best describes you?',
        type: 'select',
      },
      {
        field_name: 'withPartner',
        isFinancial: true,
        isHidden: false,
        options: ['Yes', 'No'],
        question: 'Do you manage finances with a partner?',
        type: 'radio',
      },
    ],
    title: 'Personal information',
  },
  {
    fields: [
      {
        field_name: 'income',
        isFinancial: true,
        isHidden: false,
        isIncomeField: true,
        placeholder: '$',
        question: 'What is your annual household income?',
        type: 'number',
      },
      {
        field_name: 'combinedIncome',
        isFinancial: true,
        isHidden: true,
        placeholder: '$',
        question:
          'If managing your finances with a partner, what is your combined annual household income?',
        type: 'number',
        visibleWhen: { fieldName: 'withPartner', value: 'Yes' },
      },
      {
        field_name: 'housingCost',
        isFinancial: true,
        isHidden: false,
        placeholder: '$',
        question:
          'What are your monthly housing costs? (i.e. mortgage or rent)',
        type: 'number',
      },
    ],
    title: 'Salary and expenses',
  },
  {
    fields: [
      {
        conditions: {
          fields: ['retirementContribute'],
          value: 'Yes',
        },
        field_name: 'retirementAccount',
        isFinancial: true,
        isHidden: false,
        options: ['Yes', 'No'],
        question: 'Do you have a 401k or retirement account?',
        type: 'radio',
      },
      {
        field_name: 'retirementContribute',
        isFinancial: true,
        isHidden: true,
        placeholder: '%',
        question: 'How much do you contribute to your retirement account?',
        type: 'number',
      },
      {
        conditions: {
          fields: ['fundAmount'],
          value: 'Yes',
        },
        field_name: 'emergencyFund',
        isFinancial: true,
        isHidden: false,
        options: ['Yes', 'No'],
        question: 'Do you have an emergency fund?',
        type: 'radio',
      },
      {
        field_name: 'fundAmount',
        isFinancial: true,
        isHidden: true,
        placeholder: '$',
        question: 'How much is in it?',
        type: 'number',
      },
      {
        field_name: 'saveMonthly',
        isFinancial: true,
        isHidden: false,
        placeholder: '$',
        question:
          'After all of your expenses, roughly how much do you save per month? (besides your retirement account)',
        type: 'number',
      },
    ],
    title: 'Savings',
  },
  {
    fields: [
      {
        conditions: {
          fields: ['Debt', 'Amount'],
          value: 'Yes',
        },
        field_name: 'outstendingDebt',
        isFinancial: true,
        isHidden: false,
        options: ['Yes', 'No'],
        question: 'Do you have any outstanding debt?',
        type: 'radio',
      },
      {
        field_name: 'Debt',
        isFinancial: true,
        isHidden: true,
        placeholder: 'Debt',
        question: 'Type',
        type: 'input',
      },
      {
        field_name: 'Amount',
        isFinancial: true,
        isHidden: true,
        placeholder: '$',
        question: 'Amount',
        type: 'number',
      },
      {
        field_name: 'coverExpanses',
        isFinancial: false,
        isHidden: false,
        options: [
          'Very challenging',
          'Somewhat challenging',
          'Neutral',
          'Not very challenging',
          'Not challenging at all',
        ],
        placeholder: 'Select',
        question:
          'How challenging is it for you to cover your expenses and pay your bills every month?',
        type: 'select',
      },
      {
        field_name: 'financeConfidence',
        isFinancial: false,
        isHidden: false,
        options: [
          'Very confident',
          'Confident',
          'Neutral',
          'Not very confident',
          'Not confident at all',
        ],
        placeholder: 'Select',
        question: 'How confident are you in managing your personal finances?',
        type: 'select',
      },
    ],
    title: 'Financial wellness',
  },
  {
    fields: [
      {
        conditions: {
          fields: ['goals'],
          value: 'Yes',
        },
        field_name: 'advisorAware',
        isFinancial: false,
        isHidden: false,
        options: ['Yes', 'No'],
        question:
          'Do you have any major life goals that you are planning for and want your planner to be aware of?',
        type: 'radio',
      },
      {
        field_name: 'goals',
        isFinancial: false,
        isHidden: true,
        placeholder: 'Goals',
        question: 'Please list and describe your goals',
        type: 'input',
      },
    ],
    title: 'Life goals',
  },
]
